import ContactList from "@/components/ContactList";

export default function Suppliers() {
  return (
    <ContactList
      title="Suppliers"
      eyebrow="Inbound · Trading partners"
      resource="suppliers"
      testPrefix="supplier"
    />
  );
}
